export const makeApiUrl = (url: string): string => {
  return 'https://api.glassen-it.com/component/socparser'
}
